module.exports = __webpack_public_path__ + "img/educabinh_icon_background.5760a105.png";